import type { GoodsFirstPageRenderingModel } from '../../../api/types';
import { bridge } from '../../bridge';
import { getWebBaseURL } from '../../getWebBaseURL';

type MoveToGoodsProps = {
  sno: number;
  firstPageRendering: GoodsFirstPageRenderingModel | null;
  loggingAnalytics?: Record<string, unknown>;
};

/**
 * - 상품 상세로 이동
 */
export const moveToGoods = ({
  firstPageRendering,
  sno,
  loggingAnalytics,
}: MoveToGoodsProps) => {
  const goodsDetailDeeplink = new URL(`ably://goods/${sno}`);

  if (loggingAnalytics) {
    goodsDetailDeeplink.searchParams.set(
      'logging_analytics',
      JSON.stringify(loggingAnalytics),
    );
  }
  if (firstPageRendering) {
    goodsDetailDeeplink.searchParams.set(
      'first_page_rendering',
      JSON.stringify(firstPageRendering),
    );
  }
  // //URLSearchParams 에서 space(' ')를 +로 인코딩하는 문제가 있어 + 대신 space(' ')를 의미하는 %20으로 치환한다.
  const parsedDeeplink = goodsDetailDeeplink.href.replaceAll('+', '%20');

  return bridge.openDeeplink(parsedDeeplink, {
    webCallback: async () => {
      const baseURL = await getWebBaseURL();
      location.href = `${baseURL}/goods/${sno}`;
    },
  });
};
